// extracted by mini-css-extract-plugin
export default {"button":"Button_button__9Q+hs","primary":"Button_primary__BzC0C","secondary":"Button_secondary__8IIFK"};